import React, { useEffect, useState } from "react"
import { Container } from "react-bootstrap"
import { Link, graphql, useStaticQuery } from "gatsby"
import { isEmpty } from "lodash"
// import clsx from "clsx"

import "./Header.scss"
import CTALink from "@components/elements/CTALink"
import SiteSearch from "@components/SiteSearch/SiteSearch"
import { officesURL, propertiesSaleURL } from "@lib/urls"
import { defaultAreaSlug } from "@common/constant"
// import useBurgerMenu from "@hooks/dataHooks/useBurgerMenu"

// import LogoMobile from "../../images/logo_mobile.svg"

import WebbersYears from "../../images/100_years_band.svg"

const Header = ({ menu_slug, removeFixedHeader }) => {
  const [showBurgerMenu, setShowBurgerMenu] = useState(false)
  const [toggleSearch, setToggleSearch] = useState(false)
  const [showSubmenu, setShowSubmenu] = useState(false)
  const [isFixed, setFixed] = useState(false);
  // const { burgerMenu } = useBurgerMenu()
   
  const handleScroll = () => {
    if(!removeFixedHeader){
      setFixed(window.pageYOffset > 0)
    }
   
  };
  const data = useStaticQuery(graphql`
    query {
      strapiGlobalMenu {
        top_links {
          ...ctaFragment
        }
        header_links {
          ...ctaFragment
        }
      }
      strapiSiteConfig {
        phone
        brand_name
        header_logo {
          url
        }
        mobile_logo {
          url
        }
        fnc_logo {
          url
        }
      }

      allStrapiBurgerMenu(
        sort: { fields: sort, order: ASC }
        filter: { publish: { eq: true } }
      ) {
        nodes {
          title
          publish
          sort
          menu: link {
            slug
            custom_link
            strapi_parent {
              slug
              custom_link
              link_type
            }
          }
          add_new {
            title
            menu: link {
              slug
              custom_link
              strapi_parent {
                slug
                custom_link
                link_type
              }
            }
          }
        }
      }
    }
  `)

  const topLinks = data?.strapiGlobalMenu?.top_links
  const headerLinks = data?.strapiGlobalMenu?.header_links
  const siteConfig = data?.strapiSiteConfig
  const burgerMenu = data?.allStrapiBurgerMenu?.nodes

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    if (showBurgerMenu || toggleSearch) {
      document.body.style.overflowY = "hidden"
    } else {
      document.body.style.overflowY = "auto"
    }
    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, [showBurgerMenu, toggleSearch])

  // console.log("burgerMenu =>", burgerMenu)

  return (
    <>
      <div className={`header ${isFixed ? "fixed" : ""}`}>
        <div className="top-nav">
          <Container>
            <ul className="d-none d-md-flex">
              {topLinks?.map((cta) => {
                return (
                  !isEmpty(cta) && (
                    <li key={cta.id}>
                      {cta.cta_label === "my webbers" ? (
                        <CTALink cta={cta}>
                          {/* my <b>webbers</b> */}
                          Login/Myaccount
                        </CTALink>
                      ) : (
                        <CTALink cta={cta} />
                      )}
                    </li>
                  )
                )
              })}
              <li>
                <a href={`tel: ${siteConfig.phone}`}>
                  <i className="icon icon-phone hover_red" /> {siteConfig.phone}
                </a>
              </li>
            </ul>
            {/* <img
              src={WebbersYears}
              alt="100 years webbers centenary"
              width="231"
              height="24"
              className="d-flex d-md-none brand_band"
            /> */}
          </Container>
        </div>

        <div className="header-menu">
          <Container className="position-relative">
            <Link to="/" className="logo">
              <img
                src={
                  menu_slug === "fine-and-country"
                    ? siteConfig.fnc_logo.url
                    : siteConfig.header_logo.url
                }
                alt="webbers logo"
                width="112"
                height="224"
                className="d-none d-md-block"
              />
              <img
                src={
                  menu_slug === "fine-and-country"
                    ? siteConfig.fnc_logo.url
                    : siteConfig.mobile_logo.url
                }
                // src={LogoMobile}
                alt="webbers logo"
                width="58"
                height="84"
                className="d-block d-md-none"
              />
            </Link>

            <div className="nav-menu">
              <ul>
                {headerLinks?.map((cta) => {
                  return (
                    !isEmpty(cta) && (
                      <li key={cta.id} className="d-none d-xl-block">
                        <CTALink cta={cta} />
                      </li>
                    )
                  )
                })}

                <li className="d-md-none d-block">
                  <Link to="/property-valuation/">Valuation</Link>
                </li>

                <li>
                  <button
                    aria-label="site-search"
                    onClick={() => setToggleSearch(!toggleSearch)}
                    className="d-none d-xl-block"
                  >
                    <i
                      className={`icon icon-search ${toggleSearch ? "hover_red" : ""
                        }`}
                    />
                  </button>
                  <Link
                    to={`${propertiesSaleURL}in-${defaultAreaSlug}`}
                    className="d-block d-xl-none"
                  >
                    <i
                      className={`icon icon-search  ${toggleSearch ? "hover_red" : ""
                        }`}
                    />
                  </Link>
                </li>
                <li className="d-xl-none d-block">
                  <Link to={`${officesURL}`}>
                    <i className="icon icon-phone_black hover_red" />
                  </Link>
                </li>
                <li className="d-xl-none d-block">
                  <a
                    href="https://my.webbers.co.uk/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="icon icon-user hover_red" />
                  </a>
                </li>
                <li className="d-xl-none d-block">
                  <button aria-label="Burger Menu">
                    <i
                      className="icon icon-burger-menu hover_red"
                      onClick={() => setShowBurgerMenu(true)}
                    />
                  </button>
                </li>
              </ul>
            </div>
          </Container>
        </div>

        {toggleSearch && <SiteSearch setToggleSearch={setToggleSearch} />}

        <div
          className={`burger-menu ${showBurgerMenu ? "d-block" : "d-none"
            } d-xl-none`}
        >
          <Container className="position-relative">
            <button type="button" className="menu-close" aria-label="menuclose">
              <i
                className="icon icon-close"
                onClick={() => setShowBurgerMenu(!showBurgerMenu)}
              />
            </button>
            <ul>
              {burgerMenu?.map((cta) => {
                return (
                  !isEmpty(cta) && (
                    <li key="">
                      <CTALink cta={cta}>{cta.title}</CTALink>
                      {cta?.add_new?.length > 0 &&
                        (showSubmenu === cta.title ? (
                          <i
                            className="icon icon-minus"
                            onClick={() => setShowSubmenu(false)}
                          />
                        ) : (
                          <i
                            className="icon icon-plus"
                            onClick={() => setShowSubmenu(cta.title)}
                          />
                        ))}

                      <ul
                        className={`${showSubmenu === cta.title ? "d-block" : "d-none"
                          }`}
                      >
                        {cta?.add_new?.map((cta2) => {
                          return (
                            <li key="">
                              <CTALink cta={cta2}>{cta2.title}</CTALink>
                            </li>
                          )
                        })}
                      </ul>
                    </li>
                  )
                )
              })}
            </ul>
          </Container>
        </div>
      </div>
      {isFixed &&
      <div className="fixed py-5"></div>
      }
    </>
  )
}

export default Header
